const Checkbox = ({ label, onUpdate, qaClasses, checked }) => {
  const inputProps = {
    type: 'checkbox',
    class: qaClasses,
    onChange: (e) => onUpdate(e.target.checked),
    checked: checked
  }

  return (
    <div class='article-creator__sidebar--checkbox'>
      <label>
        <input {...inputProps} />
        {label}
      </label>
    </div>
  )
}

export default Checkbox
